import './molecules/arc-number/arc-number';
import './molecules/map/map';

import './organisms/announcement/announcement';

import './templates/hero-carousel/hero-carousel';
import './templates/our-newsletter/our-newsletter';
import './templates/section-show-more/section-show-more';
import './templates/header/header';
import './templates/teachings/teachings';
import './templates/pagination-bandi/pagination-bandi';
import './templates/even-odd-service/even-odd-service';



// WEBPACK FOOTER //
// ./src/components/_components.js